module.exports = __webpack_public_path__ + "media/dorobek/assets/images/sciencecloud-icon-eeabe4fc9bf56f4710a873c6b7ff4847.png";